const CELL_KEY_SEPARATOR = '::';

export function createCellKey(rowId: string, colId: string): string {
  return `${rowId}${CELL_KEY_SEPARATOR}${colId}`;
}

export function extractRowIdFromCellKey(cellKey: string): string {
  const separatorIndex = cellKey.indexOf(CELL_KEY_SEPARATOR);
  return separatorIndex === -1 ? cellKey : cellKey.slice(0, separatorIndex);
}
